import { fetchGet, objectify } from '../../utils'


export const getBreaks = (query) => {
  const ProductId = query
  return fetchGet(`/InventoryEnquiry/Product/${ProductId}/Pricing/FutureBreaks`, null, 'Inline')
    .then((result) => result && objectify(result.PricingFutureBreakss[0]))
}